<div class="container-fluid">
    <div class="row zsd-cust-common-container">
        <div class="col-lg-3 col-xl-2"></div>
        <div  class="col-lg-9 col-xl-10 col-md-9 col-xs-10 col-sm-10 col-10 pl-3 py-2">
            <span class="zsd-cust-common-pageheading-font">
                {{ "SelfHelp.knowledgebase" | translate | uppercase }}
              </span>
        </div>
        <div class="col-md-3 col-xs-2 col-sm-2 col-2">
            <span style="float: right;">
                <em class="fa fa-filter d-block d-lg-none filter-action" (click)="openFilter()"></em>
            </span>
        </div>
    </div>
    <div class="row">
        <!-- style="position: sticky !important; top: 56px; z-index: initial;  max-width: 230px; max-height: 90vh; overflow: auto;" -->
        <div class="col-lg-3 col-xl-2">
            <zsd-knowledgebasefilter></zsd-knowledgebasefilter>
        </div>
        <div class="col-lg-9 col-xl-10 col-md-12 col-xs-12 col-sm-12 col-12">
            <zsd-knowledgebase></zsd-knowledgebase>
        </div>
    </div>
</div>
<router-outlet></router-outlet>